import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from '../../../system/components/Input';

interface Props {
  form: WrappedFormUtils;
  initialValue?: string;
}

export const InputAddress1: FC<Props> = ({ form, initialValue }): JSX.Element => (
  <Form.Item label="Address:">
    {form.getFieldDecorator('address1', {
      initialValue,
      rules: [{ message: 'Please enter the location street address.', required: true }],
    })(<Input allowClear placeholder="Address" />)}
  </Form.Item>
);
